/**
 * Contains all global settings (specific for this environment)
 */
export const globalSettingsContextKey = "globalSettings";
